import React from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  saveRoute,
  cancelRouteEdit,
} from "../../../reducers/routeManagement/thunkActions";
import {
  routeEditCopySelector,
  routeEditSelector,
  isRouteEditValidSelector,
} from "../../../reducers/routeManagement/selectors";

import { View } from "../../View";
import { CancelSaveActionButtons } from "../Common/CancelSaveActionButtons";

const LockComponent = () => {
  const dispatch = useDispatch();
  const routeEdit = useSelector(routeEditSelector);
  const routeChanged = routeEdit !== useSelector(routeEditCopySelector);
  const isRouteValid = useSelector(isRouteEditValidSelector);

  const shouldDisableSave = () => !routeEdit || !routeChanged || !isRouteValid;

  return (
    <View>
      <View>
        {routeEdit && (
          <CancelSaveActionButtons
            onCancelClick={() => dispatch(cancelRouteEdit())}
            onSaveClick={() => dispatch(saveRoute())}
            saveDisabled={shouldDisableSave()}
          />
        )}
      </View>
    </View>
  );
};

export default LockComponent;
